module.exports = __webpack_public_path__ + "img/sms.26e9af0c.png";